// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

// helpers
import { validateFileName } from "../../../helpers/validate";
import {
  formatBytes,
  removeUnwantedFiles,
  jumpToError,
} from "../../../helpers/renderHelpers";
import { fileUploaded } from "../../../helpers/actionsHelpers";

// redux actions
import { saveAppState } from "../../../actions/appActions";
import { deleteFile } from "../../../actions/formActions";

// render components
import RenderField from "../../global/RenderField";

class supportingDocuments extends React.Component {
  componentDidMount() {
    const { attachments, deleteFile, formData } = this.props;
    removeUnwantedFiles(attachments, deleteFile, formData);
  }

  render() {
    const {
      formData,
      attachments,
      formName,
      handleSubmit,
      previousPage,
      appState,
      isAppSaving,
      saveAppState,
      deleteFile,
    } = this.props;

    let filesUploading = attachments.find((attachment) => {
      return attachment.isUploading && !attachment.transactionID;
    });

    let requiredFile = (name) =>
      attachments.filter((file) => file.id === name && file.transactionID)
        .length > 0
        ? null
        : "Uploaded attachment required";

    let feeWaiverRegFound = [];
    if (formData.feeWaiverActivities) {
      feeWaiverRegFound = formData.feeWaiverActivities.filter((activity) => {
        return activity.regulation === "r26(e)";
      });
    }

    return (
      <form id={formName} onSubmit={handleSubmit}>
        <h2>Supporting documents</h2>
        <p>
          You are now required to upload any required supporting documentation
          and any additional supporting documentation you would like to include
          that will assist us to evaluate your application by uploading your
          files below under the corresponding heading.
        </p>
        <p>A maximum file size of 40MB applies.</p>

        <ul className="list">
          <li className="list-tile info">
            <div className="list-tile-content">
              {fileUploaded(attachments) === undefined ? (
                <span>
                  <p>
                    Before uploading any supporting documentation, it is
                    important to have all supporting documentation ready to
                    upload as this is the{" "}
                    <span style={{ fontWeight: "600" }}>
                      last chance in the application you can save and exit
                    </span>
                    . For your privacy we will not save supported documentation
                    until the application is submitted. You cannot save and exit
                    if any supporting documentation has been uploaded.
                  </p>
                  <p>
                    If you wish to leave this form and prepare all supporting
                    documentation. We recommend you save and exit now. An email
                    will be sent to the primary contact email address where you
                    can retrieve this application.
                  </p>
                </span>
              ) : (
                <p>
                  Supporting documentation has been attached to the form, for
                  your privacy we will not save supported documentation until
                  the application is submitted. If you need to save and exit the
                  form, you will need to remove all uploaded supporting
                  documentation.
                </p>
              )}
              <button
                type="button"
                className="sq-form-page-button"
                onClick={() => saveAppState(appState, formName)}
                disabled={isAppSaving || fileUploaded(attachments)}
              >
                Save and Exit
              </button>
            </div>
          </li>
        </ul>

        <div className="sq-form-section">
          <div className="sq-form-section-description">
            <h3>Heritage impact statement</h3>
          </div>
          <Field
            name="impactOfProposedWorksDocument"
            type="file"
            label="Please upload here a Heritage Impact Statement that has been prepared for this application."
            component={RenderField}
            category="Application"
            subCategory="Heritage Impact Statement"
            validate={
              requiredFile("impactOfProposedWorksDocument") &&
              validateFileName(attachments)
            }
            required
          />
        </div>

        <div className="sq-form-section">
          <div className="sq-form-section-description">
            <h3>Costs of works</h3>
          </div>
          <Field
            name="costOfWorksDocument"
            type="file"
            label="Please supply quotes or cost breakdown for the proposed works."
            component={RenderField}
            category="Application"
            subCategory="Cost Of Works"
            multiple={true}
            validate={() => requiredFile("costOfWorksDocument")}
            required
          />
        </div>

        {formData.worksOnCrownLandFlag === "false" && (
          <div className="sq-form-section">
            <div className="sq-form-section-description">
              <h3>Land title documents</h3>
            </div>
            <Field
              name="crownLandDocument"
              type="file"
              label="Please upload relevant title(s) issued within the last 30 days."
              component={RenderField}
              category="Application"
              subCategory="Land Titles"
              multiple={true}
              validate={() => requiredFile("crownLandDocument")}
              required
            />
          </div>
        )}

        {formData.chmpRequiredFlag === "true" &&
          formData.chmpApprovedFlag === "true" && (
            <div className="sq-form-section">
              <div className="sq-form-section-description">
                <h3>Cultural heritage management plan approval</h3>
              </div>
              <Field
                name="chmpDocument"
                type="file"
                label="Please upload here the approved Cultural Heritage Management Plan."
                component={RenderField}
                category="Application"
                subCategory="Cultural Heritage Management Plan"
                multiple={true}
                validate={() => requiredFile("chmpDocument")}
                required
              />
            </div>
          )}

        {formData.feeWaiverOrExemption === "exemption" && (
          <div className="sq-form-section">
            <div className="sq-form-section-description">
              <h3>Fee exemption documents</h3>
              <p>Example of Fee Exemption documents include:</p>
              <ul>
                <li>
                  A Health care card issued under section 1061Z of the{" "}
                  <span style={{ fontStyle: "italic" }}>
                    Social Security Act 1991
                  </span>{" "}
                  of the Commonwealth other than in respect of a child in foster
                  care, or a child in respect of whom a carer allowance under
                  section 953 of that Act is payable?
                </li>
                <li>
                  A Gold Card issued in respect of Part V of the{" "}
                  <span style={{ fontStyle: "italic" }}>
                    Veterans' Entitlements Act 1986
                  </span>{" "}
                  of the Commonwealth other than a dependant (not including the
                  widow or widower) of a veteran?
                </li>
                <li>
                  A pensioner concession card issued under section 1061ZF of the{" "}
                  <span style={{ fontStyle: "italic" }}>
                    Social Security Act 1991
                  </span>{" "}
                  of the Commonwealth
                </li>
                <li>Drivers licence</li>
                <li>
                  Current rates notice for your principal place of residence
                </li>
              </ul>
            </div>
            <Field
              name="feeExemptionDocument"
              type="file"
              label="Please provide copies of the relevant card and either your driver's licence or a current rates notice for your principal place of residence to confirm your eligibility."
              component={RenderField}
              category="Application"
              subCategory="Fee Exemption"
              multiple={true}
              validate={() => requiredFile("feeExemptionDocument")}
              required
            />
          </div>
        )}

        {formData.feeWaiverOrExemption === "waiver" && (
          <div className="sq-form-section">
            <div className="sq-form-section-description">
              <h3>Fee waiver documents</h3>
              <ul className="list">
                <li className="list-tile info">
                  <div className="list-tile-content">
                    <p>You have applied for a fee waiver in accordance with:</p>
                    <ul className="list-tile-content">
                      {formData.feeWaiverActivities.map((activity, i) => (
                        <li key={i}>
                          {activity.regulation}, where{" "}
                          {activity.category.charAt(0).toLowerCase() +
                            activity.category.slice(1)}
                          {i + 1 === formData.feeWaiverActivities.length
                            ? "."
                            : "; and"}
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li className="list-tile info">
                  {feeWaiverRegFound.length > 0 && (
                    <div className="list-tile-content">
                      <p>
                        Please note that the Heritage Regulations define a
                        community group as being:
                      </p>
                      <ul className="list-tile-content">
                        <li>
                          established for the purpose of educating the community
                          about, or to protect, a place or object; and
                        </li>
                        <li>
                          whose officers receive no remuneration or gratuity for
                          their services to the society, association or club.
                        </li>
                      </ul>
                      <p>
                        For your fee waiver application to be successful, you
                        must supply evidence that your group meets the above
                        criteria, by uploading a club charter, statutory
                        declaration or other documentation demonstrating your
                        eligibility.
                      </p>
                    </div>
                  )}
                </li>
              </ul>
            </div>
            <Field
              name="feeWaiverDocument"
              type="file"
              label="Please supply evidence to support your Fee Waiver application."
              component={RenderField}
              category="Application"
              subCategory="Fee Waiver"
              multiple={true}
              validate={
                feeWaiverRegFound.length > 0
                  ? () => requiredFile("feeWaiverDocument")
                  : null
              }
              required={feeWaiverRegFound.length > 0 ? "required" : null}
            />
          </div>
        )}

        {formData.feeWaiverOrExemption === "notApplicable" && (
          <div className="sq-form-section">
            <div className="sq-form-section-description">
              <h3>Payment receipt documents</h3>
            </div>
            <Field
              name="paymentDocument"
              type="file"
              label="Please upload here a copy of your receipt of payment."
              component={RenderField}
              category="Application"
              subCategory="Payment Receipt"
              multiple={true}
              validate={() => requiredFile("paymentDocument")}
              required
            />
          </div>
        )}

        <CategoryDocumentContainer formData={formData} />

        <div className="sq-form-section">
          <div className="sq-form-section-description">
            <h3>
              Consent letter
              {formData.owners.length > 1 ||
              formData.isCommonPropertyInvolved === "true"
                ? "s"
                : ""}
            </h3>
          </div>

          {formData.owners.map((owner, i) => (
            <Field
              key={i}
              name={`consentLetter-owner${i + 1}`}
              type="file"
              label={`Owner #${i + 1} (${owner.title} ${owner.givenName} ${
                owner.familyName
              }) consent letter.`}
              showLabel
              note={
                i === 0 &&
                formData.sameAsPrimaryContact &&
                formData.sameAsPrimaryContact.length > 0 &&
                formData.sameAsPrimaryContactApplicant
                  ? `If you would like to include a written consent letter from ${owner.title} ${owner.givenName} ${owner.familyName} consenting to this application for the proposed works, upload here.`
                  : `Upload here a written consent letter from ${owner.title} ${owner.givenName} ${owner.familyName} consenting to this application for the proposed works.`
              }
              component={RenderField}
              category="Application"
              subCategory="Consent Letter"
              validate={
                i === 0 &&
                formData.sameAsPrimaryContact &&
                formData.sameAsPrimaryContact.length > 0 &&
                formData.sameAsPrimaryContactApplicant
                  ? null
                  : () => requiredFile(`consentLetter-owner${i + 1}`)
              }
              required={
                i === 0 &&
                formData.sameAsPrimaryContact &&
                formData.sameAsPrimaryContact.length > 0 &&
                formData.sameAsPrimaryContactApplicant
                  ? null
                  : true
              }
            />
          ))}

          {formData.isCommonPropertyInvolved === "true" && (
            <Field
              name="consentLetter-ownersCorpManager"
              type="file"
              label={`Owners Corporation Manager (${formData.ownersCorpManagerDetails.title} ${formData.ownersCorpManagerDetails.givenName} ${formData.ownersCorpManagerDetails.familyName}) consent letter.`}
              showLabel
              note={`Upload here a written consent letter from ${formData.ownersCorpManagerDetails.title} ${formData.ownersCorpManagerDetails.givenName} ${formData.ownersCorpManagerDetails.familyName} consenting to this application for the proposed works.`}
              component={RenderField}
              category="Application"
              subCategory="Consent Letter"
              validate={() => requiredFile("consentLetter-ownersCorpManager")}
              required
            />
          )}
        </div>

        <div className="sq-form-section">
          <div className="sq-form-section-description">
            <h3>Other documents</h3>
            <p>
              If you have any other supporting documents that do not fall into
              the above categories, please upload them here.
            </p>
          </div>
          <Field
            name="otherDocumentTile"
            type="file"
            component={RenderField}
            category="Application"
            subCategory="Other"
            multiple={true}
          />
        </div>

        {attachments && attachments.length > 0 && filesUploading && (
          <div className="sq-form-section">
            <div className="sq-form-section-description">
              <h3>Uploading progress</h3>
            </div>
            <ul className="list">
              <li className="list-tile">
                <ul className="list-tile-content list list-uploadFile">
                  {attachments.map((attachment, i) => {
                    return attachment.isUploading &&
                      !attachment.transactionID ? (
                      <li key={i} className="list-tile uploading">
                        <div className="list-tile-content">
                          <div className="list-tile-content-name">
                            <p>
                              <span>Uploading...</span>
                              {attachment.originalFileName} (
                              {formatBytes(attachment.fileSize, 2)})
                            </p>
                          </div>
                          <div
                            className="list-tile-progress"
                            style={{
                              backgroundImage: `linear-gradient(to right,#00b7bd ${attachment.percentage}%,#d5d5d5 ${attachment.percentage}%)`,
                            }}
                          />
                        </div>
                      </li>
                    ) : null;
                  })}
                </ul>
              </li>
            </ul>
            <p className="sq-form-error">
              Cannot proceed while files are uploading
            </p>
          </div>
        )}

        <div className="sq-form-control">
          <button
            type="button"
            className="sq-form-page-button previous"
            onClick={previousPage}
          >
            Previous
          </button>
          <button
            type="submit"
            className="sq-form-page-button next"
            disabled={
              (attachments && attachments.length > 0 && filesUploading) ||
              !validFileNames(attachments)
            }
            onClick={() => {
              jumpToError();
              removeUnwantedFiles(attachments, deleteFile, formData);
            }}
          >
            Next
          </button>
        </div>
      </form>
    );
  }
}

/**
 * Determine if the files have valid names. If not, return false.
 *
 * @param {array} files   An array of objects representing the uploaded
 *                        files.
 *
 * @return {boolean}  valid
 */
const validFileNames = (files) => {
  let valid = true;

  if (files.length > 0) {
    files.forEach((file) => {
      if (
        file.originalFileName.length > 120 ||
        // eslint-disable-next-line no-control-regex
        !/^[\x00-\x7F]*$/.test(file.originalFileName)
      ) {
        valid = false;
      }
    });
  }

  return valid;
};

const CategoryDocumentContainer = (props) => {
  const { formData } = props;

  let supportiveDocumentCategories = [];
  if (
    formData &&
    formData.workCategories &&
    formData.workCategories.length >= 1
  ) {
    let categoriesNumrows = formData.workCategories.length;
    for (var i = 0; i < categoriesNumrows; i++) {
      supportiveDocumentCategories.push(
        <CategoryDocumentTile
          key={i}
          arrayPosition={i}
          formData={formData}
          categoryTitle={formData.workCategories[i].category}
          categoryExample={formData.workCategories[i].examples}
          categoryType={formData.workCategories[i].types}
        />
      );
    }
  }

  return (
    <div>
      {formData &&
        formData.workCategories &&
        formData.workCategories.length > 0 &&
        supportiveDocumentCategories}
    </div>
  );
};

const CategoryDocumentTile = (props) => {
  const { categoryTitle, categoryExample, categoryType } = props;

  return (
    <div className="sq-form-section categoryDocument-tile">
      <div className="sq-form-section-description">
        <h3>{categoryTitle} Documents</h3>
        <p>Example of {categoryTitle} documents include:</p>
        <CategoryDocumentExample categoryExample={categoryExample} />
        <CategoryDocumentTypeContainer
          categoryType={categoryType}
          categoryTitle={categoryTitle}
        />
      </div>
    </div>
  );
};

const CategoryDocumentExample = (props) => {
  const { categoryExample } = props;

  let categoryExamples = [];
  let categoryExampleNumrows = categoryExample.length;

  for (var j = 0; j < categoryExampleNumrows; j++) {
    categoryExamples.push(<li key={j}>{categoryExample[j]}</li>);
  }

  return <ul>{categoryExamples}</ul>;
};

const CategoryDocumentTypeContainer = (props) => {
  const { formData, categoryType, categoryTitle } = props;

  let categoryTypes = [];
  let categoryExampleNumrows = categoryType.length;

  for (var h = 0; h < categoryExampleNumrows; h++) {
    categoryTypes.push(
      <CategoryDocumentTypeTile
        key={h}
        arrayPosition={h}
        formData={formData}
        categoryTitle={categoryTitle}
        typeName={categoryType[h]}
      />
    );
  }

  return (
    <div key={h} className="categoryDocument-type-wrapper">
      {categoryType.length > 0 && categoryTypes}
    </div>
  );
};

const CategoryDocumentTypeTile = (props) => {
  const { typeName, categoryTitle } = props;
  return (
    <div className="categoryDocument-type-tile">
      <h4>{typeName}</h4>
      <Field
        name={`${categoryTitle}${typeName}DocumentTile`}
        type="file"
        component={RenderField}
        category={categoryTitle}
        subCategory={typeName}
        multiple={true}
      />
    </div>
  );
};

const mapStateToProps = (state, formName) => {
  return {
    formData: state.form[formName.form] ? state.form[formName.form].values : {},
    attachments: state.service.attachments,
    isAppSaving: state.app.isAppSaving,
    appState: state,
  };
};

const mapDispatchToProps = {
  saveAppState,
  deleteFile,
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(form(supportingDocuments));
